import axios from "./axios";
import store from "../store";

export default {
  getRawCreditsOptions() {
    return [
      { text: "2000", value: 0 },
      { text: "3000", value: 0 },
      { text: "5000", value: 0 },
      { text: "10000", value: 0 },
    ];
  },
  getPerSMSPriceObj() {
    return {
      perSMS: 0.45,
      perSMS5000: 0.33,
      perSMS1000: 0.28,
    };
  },
  getPerSMSRate(credits) {
    const perSMSPrices = this.getPerSMSPriceObj();
    if (credits === 10000) {
      return `${store.getters.getCurrency}${perSMSPrices.perSMS1000.toFixed(
        2
      )}`;
    } else if (credits === 5000) {
      return `${store.getters.getCurrency}${perSMSPrices.perSMS5000.toFixed(
        2
      )}`;
    } else {
      return `${store.getters.getCurrency}${perSMSPrices.perSMS.toFixed(2)}`;
    }
  },
  formatMoney(value) {
    return Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  },
  getCredits() {
    const rawCredits = this.getRawCreditsOptions();
    const perSMSPrices = this.getPerSMSPriceObj();

    const creds = [];
    rawCredits.forEach((credit) => {
      if (credit.text == "10000") {
        const price = (
          Number(credit.text) * Number(perSMSPrices["perSMS1000"])
        ).toFixed(2);
        const obj = {
          credits: Number(credit.text),
          price: price,
        };
        creds.push({
          text: `${credit.text} Credits @ ${
            store.getters.getCurrency
          }${this.formatMoney(price)}`,
          value: obj,
        });
      } else if (credit.text == "5000") {
        const price = (
          Number(credit.text) * Number(perSMSPrices["perSMS5000"])
        ).toFixed(2);
        const obj = {
          credits: Number(credit.text),
          price: price,
        };
        creds.push({
          text: `${credit.text} Credits @ ${
            store.getters.getCurrency
          }${this.formatMoney(price)}`,
          value: obj,
        });
      } else {
        const price = (
          Number(credit.text) * Number(perSMSPrices["perSMS"])
        ).toFixed(2);
        const obj = {
          credits: Number(credit.text),
          price: price,
        };
        creds.push({
          text: `${credit.text} Credits @ ${
            store.getters.getCurrency
          }${this.formatMoney(price)}`,
          value: obj,
        });
      }
    });
    return creds;
  },
  async sendSMS(
    url,
    message,
    schedule,
    dateTime,
    numbers,
    radioBtnChoice = 1,
    selectedPredefinedSMS = null
  ) {
    const messages = await axios.postDataWithToken(
      url,
      {
        message,
        schedule,
        dateTime,
        numbers,
        radioBtnChoice,
        selectedPredefinedSMS,
      },
      localStorage.getItem("token")
    );
    return messages;
  },
  async getSMSCredits(url = "/auth/get-sms-credits") {
    const smsCredits = await axios.getData(url, localStorage.getItem("token"));
    return smsCredits;
  },
  async getSMSCreditsNoToken(emis) {
    const SMSCredits = await axios.postData("/auth/get-sms-credits-no-token", {
      emis,
    });
    return SMSCredits;
  },
  async getAllPredefinedSMSes(url) {
    const predefinedSMSes = await axios.getData(
      url,
      localStorage.getItem("token")
    );
    return predefinedSMSes;
  },
  async getSMSAnalytics(url) {
    const SMSAnalytics = await axios.getData(
      url,
      localStorage.getItem("token")
    );
    return SMSAnalytics;
  },
};
